<template>
  <b-card no-body id="tasksList">
    <b-card-header class="border-0">
      <div class="d-flex align-items-center">
        <h5 class="card-title mb-0 flex-grow-1">保养请求</h5>
        <div class="flex-shrink-0">
          <div class="d-flex flex-wrap gap-2">
            <b-button
              variant="success"
              class="add-btn"
              @click="handlerJump('add')"
            >
              <i class="ri-add-line align-bottom me-1"></i>
              添加
            </b-button>
          </div>
        </div>
      </div>
    </b-card-header>
    <!-- 搜索栏 -->
    <b-card-body
      class="searchBox border border-dashed border-end-0 border-start-0"
    >
      <b-form>
        <b-row class="g-3">
          <b-col xxl="3" sm="12">
            <div class="search-box">
              <input
                type="text"
                class="form-control search"
                placeholder="设备名称 / 客户名称 / 请求人 / 联系电话"
                v-model="searchQuery"
              />
              <i class="ri-search-line search-icon"></i>
            </div>
          </b-col>

          <b-col xxl="3" sm="4">
            <flat-pickr
              v-model="filterdate"
              placeholder="选择创建时间"
              :config="dateconfig"
              class="form-control"
            ></flat-pickr>
          </b-col>
          <!-- 紧急程度 -->
          <b-col xxl="2" sm="4">
            <div class="input-light">
              <Multiselect
                v-model="filtervalue1"
                :close-on-select="true"
                :searchable="true"
                :create-option="true"
                :options="priorityOptions"
              />
            </div>
          </b-col>
          <!-- 状态 -->
          <b-col xxl="2" sm="3">
            <div class="input-light">
              <Multiselect
                v-model="filtervalue2"
                :close-on-select="true"
                :searchable="true"
                :create-option="true"
                :options="statusOptions"
              />
            </div>
          </b-col>
          <b-col xxl="1" sm="3">
            <b-button
              type="button"
              variant="primary"
              class="w-100"
              @click="searchData"
            >
              <i class="ri-equalizer-fill me-1 align-bottom"></i>
              搜索
            </b-button>
          </b-col>
          <b-col xxl="1" sm="3">
            <b-button
              type="button"
              variant="info"
              class="w-100"
              @click="resetSearch"
            >
              <i class="ri-restart-line me-1 align-bottom"></i>
              重置
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
    <!-- 表单区域 -->
    <b-card-body class="overflow-auto">
      <div class="table-responsive table-card">
        <table class="table align-middle table-nowrap mb-0" id="tasksTable">
          <thead class="table-light text-muted">
            <tr>
              <th
                class="sort"
                :data-sort="head"
                v-for="(head, h_index) in tableHead"
                :key="h_index"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tbody class="list form-check-all">
            <tr v-for="body of paginate(tableBody)" :key="body.id">
              <td>
                {{
                  body.created_at
                    ? moment(body.created_at).format("YYYY-MM-DD hh:mm:ss")
                    : "--"
                }}
              </td>
              <td class="cursor-pointer">
                <a href="javascript:;" @click="handlerJump('detail', body.id)">
                  {{ body.number }}
                </a>
              </td>
              <td>{{ body.device_name }}</td>
              <td>{{ body.customer_contact }}</td>
              <td>{{ body.maintain_content }}</td>
              <td>{{ body.agent_name }}</td>
              <td>{{ body.expectation_at }}</td>
              <td>
                <span :class="['badge', statusColor[body.status]]">{{
                  filterStatus(body.status)
                }}</span>
              </td>
              <td>
                <div class="d-flex action-style">
                  <div
                      class="me-1 cursor-pointer"
                      @click="handlerAction('add', body)"
                  >
                    <i class="ri-shield-flash-fill"></i>
                  </div>
                  <div
                      class="cursor-pointer"
                      @click="handlerAction('delete', body)"
                  >
                    <i class="ri-close-circle-fill"></i>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card-body>
  </b-card>
  <Pagination
    v-if="tab_info_length"
    v-model:page="page"
    v-model:perPage="perPage"
    :pages="pages"
    :prePageOption="prePageOption"
    :tab_info_length="tab_info_length"
    class="me-5 my-3"
  ></Pagination>
</template>

<script>
import {
  tableHead,
  // tableBody,
  statusOptions,
  priorityOptions,
  priorityColor,
  statusColor,
  filterStatus,
  filterPriority,
} from "./data.js";
import moment from "moment";
import { getRepairList, deleteRepairService } from "@/service/index";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      tableHead,
      // tableBody,
      statusOptions,
      priorityOptions,
      priorityColor,
      statusColor,
      tableBody: [],
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      dateconfig: {
        wrap: true,
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      searchQuery: null,
      filterdate: null,
      filtervalue1: null,
      filtervalue2: null,
    };
  },
  computed: {},
  watch: {
    tableBody: {
      handler() {
        this.setPages();
      },
      deep: true,
    },
    perPage() {
      this.setPages();
    },
  },
  mounted() {
    this.setPages();
    this.initRepairRequest({ page_size: 0 });
  },
  methods: {
    moment,
    filterStatus,
    filterPriority,
    initRepairRequest(params) {
      getRepairList(params).then((res) => {
        if (res && res.payload && res.payload.results) {
          this.tableBody = res.payload.results;
        }
      });
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.tableBody.length;
      let numberOfPages = Math.ceil(this.tableBody.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    /* 筛选分页数据 */
    paginate(orders) {
      if (orders && orders.length) {
        let page = this.page;
        let perPage = this.perPage;
        let from = page * perPage - perPage;
        let to = page * perPage;
        return orders.slice(from, to);
      }
    },
    resetSearch() {
      this.filterdate = null;
      this.searchQuery = null;
      this.filtervalue1 = null;
      this.filtervalue2 = null;
      this.initRepairRequest();
    },
    searchData() {
      let search = {};
      if (this.searchQuery) {
        search.device_name = this.searchQuery;
        search.customer_txt = this.searchQuery;
        search.customer_contact = this.searchQuery;
        search.customer_contact_number = this.searchQuery;
      }
      if (this.filterdate) {
        if (this.filterdate.includes("至")) {
          let start_time = this.filterdate.split("至")[0].trim();
          let end_time = this.filterdate.split("至")[1].trim();
          search.created_at_after = start_time;
          search.created_at_before = end_time;
        } else {
          search.created_at = this.filterdate;
        }
      }
      if (this.filtervalue1) {
        search.priority = this.filtervalue1;
      }
      if (this.filtervalue2) {
        search.status = this.filtervalue2;
      }
      this.initRepairRequest(search);
    },
    handlerJump(type, id) {
      switch (type) {
        case "detail":
          this.$router.push({
            path: "/maintain-request/detail/" + id,
          });
          break;
        case "add":
          this.$router.push({
            path: "/maintain-request/add",
          });
          break;
      }
    },
    handlerAction(type, data) {
      switch (type) {
        case "delete":
          this.deleteService(data);
          break;
        case "add":
          this.jumpOrder(data);
          break;
      }
    },
    deleteService(data) {
      Swal.fire({
        title: this.$t("base.delete_alert_title"),
        text: this.$t("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: this.$t("base.done"),
        cancelButtonText: this.$t("base.cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          deleteRepairService(data.id)
            .then((res) => {
              if (res) {
                Swal.fire(
                  this.$t("base.success"),
                  this.$t("base.delete_alert_completed"),
                  "success"
                );
              }
            })
            .then(() => {
              this.initRepairRequest({ page_size: 0 });
            })
            .catch((e) => {
              this.formValidataAlert = true;
              this.alertInfo = {
                variant: "danger",
                content: e.message,
                icon: "ri-alert-line",
              };
              setTimeout(() => {
                this.formValidataAlert = false;
              }, 4000);
            });
        }
      });
    },
    jumpOrder(data) {
      this.$router.push({
        path: "/work-order-add",
        query: {
          id: data.id,
        },
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
#tasksList {
  flex: 1;
  overflow: hidden;
}
.action-style {
  color: #405189;
  font-size: 18px;
}
</style>
